.screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
}
.avatar {
  position: relative;
  width: 84px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-accent-100);
  color: var(--color-accent-700);
  border-radius: 50%;
  animation: evx-fadeUp 0.5s ease 0.1s both;
}
.avatarRing {
  position: absolute;
  inset: -10px;
  border: 1px solid var(--color-accent-300);
  border-radius: 50%;
  animation: evx-ringPulse 2s ease-out infinite;
}
.greeting {
  text-align: center;
}
.salutation {
  font-size: 14px;
  letter-spacing: 0.1em;
  color: var(--color-neutral-700);
  font-weight: 700;
  animation: evx-reveal 0.8s ease 0.2s both;
}
.name {
  margin: 12px 0 6px;
  font-size: 58px;
  font-weight: 800;
  color: var(--color-text);
  animation: evx-track 1.2s cubic-bezier(0.2, 0.7, 0.2, 1) 0.3s both;
}
.facts {
  display: flex;
  margin: 0;
  overflow: hidden;
  animation: evx-fadeUp 0.5s ease 0.6s both;
}
.fact {
  padding: 18px 30px;
  border-right: 1px solid var(--color-divider);
}
.fact:last-child {
  border-right: none;
}
.fact dd {
  margin: 0;
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 19px;
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
}
.footnote {
  font-size: 12px;
  color: var(--color-neutral-500);
  font-weight: 600;
  animation: evx-reveal 0.8s ease 0.8s both;
}
